module.exports = __webpack_public_path__ + "img/LogoDashboard-5.ec4ccadb.svg";